import { Input, InputContainer, ErrorText, Container } from './style'

import GCloseButton from 'src/components/gButtons/gCloseButton'
import { theme } from 'src/styles/themes/default'
import { KeyboardEvent } from 'react'

type ButtonProps = {
  color?: string
} & Pick<Props, 'onButtonClick' | 'buttonType'>

const Button = ({ onButtonClick, buttonType, color }: ButtonProps) => {
  switch (buttonType) {
    case 'close':
      return (
        <GCloseButton
          position="absolute"
          top={9}
          left={141}
          onClose={onButtonClick}
          color={color}
        />
      )

    default:
      return null
  }
}

type ButtonType = 'close' | 'eye'
type Props = {
  widht: number
  height: number
  value: string
  setValue: (value: string) => void
  placeholder: string
  mask?: string
  onSubmit?: (zipcode?: string) => void
  isInvalidField?: boolean
  setIsInvalidZipcode?: (value: boolean) => void
  errorText?: string
  buttonType?: ButtonType
  onButtonClick?: () => void
  onKeyPress?: (e: KeyboardEvent<HTMLInputElement>) => void
}

const GInputText = ({
  widht,
  height,
  value,
  setValue,
  placeholder,
  mask,
  onSubmit,
  isInvalidField,
  setIsInvalidZipcode,
  errorText,
  buttonType,
  onButtonClick,
  onKeyPress,
}: Props) => {
  return (
    <Container>
      <InputContainer width={widht} height={height}>
        <Input
          type="text"
          placeholder={placeholder}
          mask={mask ?? ''}
          onKeyPress={(e) => {
            e.key === 'Enter' && onSubmit && onSubmit()
            onKeyPress && onKeyPress(e)
          }}
          onChange={(e) => {
            setValue(e.target.value)
            setIsInvalidZipcode && setIsInvalidZipcode(false)
          }}
          value={value}
          className={isInvalidField ? 'invalid' : ''}
        />
        <Button
          onButtonClick={onButtonClick}
          buttonType={buttonType}
          color={isInvalidField ? theme.error : undefined}
        />
      </InputContainer>
      {isInvalidField && <ErrorText>{errorText ?? 'Campo inválido'}</ErrorText>}
    </Container>
  )
}

export default GInputText
